import axios, { AxiosResponse } from 'axios';

import { IApiListParams, IFeedBoardApiListResponse, IFeedLiveApiListResponse, IFeedPregameApiListResponse } from '@/types';

export const loadFeedLive = (params: IApiListParams): Promise<AxiosResponse<IFeedLiveApiListResponse>> => {
    return axios.get('/api/feedLive/list', { params });
};

export const loadFeedToday = (params: IApiListParams): Promise<AxiosResponse<IFeedPregameApiListResponse>> => {
    return axios.get('/api/feedDball/list', { params });
};

export const loadFeedBoard = (params: IApiListParams): Promise<AxiosResponse<IFeedBoardApiListResponse>> => {
    return axios.get('/api/favourite/list', { params });
};

export const loadFeedLiveGuest = (params: IApiListParams): Promise<AxiosResponse<IFeedLiveApiListResponse>> => {
    return axios.get('/api/feedLiveGuest/list', { params });
};

export const loadFeedTodayGuest = (params: IApiListParams): Promise<AxiosResponse<IFeedPregameApiListResponse>> => {
    return axios.get('/api/feedDballGuest/list', { params });
};
